import { useNavigate } from 'react-router'
import { CompaniesSection } from '../features/admin/Companies.tsx'
import { PeopleSection } from '../features/people/People.tsx'
import './admin.css'

/**
 * EMPRESAS E PESSOAS num ícone só da barra lateral
 * (SPEC-20261010-1216-empresas-e-pessoas-num-icone, pedido do Cristian:
 * "juntar empresa e pessoas em um único ícone na barra, e dentro poder ter a
 * lista de empresa como é hoje e uma aba que ao clicar tenha somente a relação
 * de pessoas e possa pesquisar a pessoa").
 *
 * As duas telas são as de antes; a aba é o endereço (/companies e /people),
 * então link, voltar do navegador e recarregar caem na aba certa.
 */
export function EmpresasEPessoasPage({ aba }: { aba: 'empresas' | 'pessoas' }) {
  const navigate = useNavigate()
  return (
    <div className="adm-page">
      <div className="adm-abas" role="tablist" aria-label="Empresas e pessoas">
        <button
          type="button"
          role="tab"
          aria-selected={aba === 'empresas'}
          className={`adm-aba${aba === 'empresas' ? ' adm-aba--on' : ''}`}
          onClick={() => navigate('/companies')}
        >
          <i className="fas fa-building" aria-hidden /> Empresas
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={aba === 'pessoas'}
          className={`adm-aba${aba === 'pessoas' ? ' adm-aba--on' : ''}`}
          onClick={() => navigate('/people')}
        >
          <i className="fas fa-address-book" aria-hidden /> Pessoas
        </button>
      </div>
      {aba === 'empresas' ? <CompaniesSection /> : <PeopleSection />}
    </div>
  )
}
